<template>
    
            <v-main class="pa-2 report_detail pcksgreport" fluid>

        <v-row>

                <v-col cols="12" md="6">
         
                  <v-text-field
                       v-model="filter"
                       append-icon="mdi-filter"
                       label="Type to filter Purchases"
                       
                     ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <RangePicker @reloadData="loadData" :range="this.getCurrentMonth()"/>
                </v-col>
              </v-row>


                 
              <v-row>
                <v-col cols="12">
                  
                  <!-- <v-subheader>Oil</v-subheader> -->
                  <v-data-table 
                      :search="filter"
                      :headers="headers" 
                      :items="resources_logs" item-key="id"
                      :items-per-page="30"
                      >
                       <template v-slot:item.checkDate="{ item }">
                          {{new Date(item.checkDate).toLocaleString("en-AU",  { timeZone : "UTC", weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}}
                      </template>
                
                      <template v-slot:item.qty="{ item }">
                      <span>{{item.qty}} {{ item.resource.unit }}</span>
                    </template>
                     
                  </v-data-table>
                  Merch Purchases coming soon
                </v-col>
                
                <!-- <v-col cols="12" md="6">
                  <v-text-field
                       v-model="filterFuel"
                       append-icon="mdi-filter"
                       label="Type to filter the Fuel Log"
                       
                     ></v-text-field>
                
                  <v-data-table 
                      :search="filterFuel"
                      :headers="headers" 
                      :items="fuel_log" item-key="id"
                      :items-per-page="30"
                      >
                       <template v-slot:item.checkDate="{ item }">
                          {{new Date(item.checkDate).toLocaleString("en-AU",  { timeZone : "UTC", weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' })}}
                      </template>
                
                      <template v-slot:item.qty="{ item }">
                      <span >{{item.qty}} gal</span>
                    </template>
                     
                  </v-data-table>
                </v-col> -->
              </v-row>
            </v-main>
    
</template>
<style>.report_detail td { text-align: left }
.report_detail .v-text-field__details { display: none }
</style>
<script>
    import { mapState } from 'vuex'
    import RangePicker from '../components/RangePicker.vue'

    export default {

      components : { RangePicker }, 

      // props : { id : {type : String, default : "0" }},
      
        data() {


            return {


              filter : '',
              filterFuel : '',

              headers : [
              { text : "Date", align: 'left', value: "checkDate", sortable : true },
              { text : "Item", align: 'left', value: "resource.name", sortable : true },
              {text : "Qty", align: 'left', value: "qty", sortable : true },

              ]
             
             
            }
        },

        mounted () {
          this.$store.dispatch('fetchResourcesLogbyDate', {
                range : this.getDefaultWeek()
            })

        },


        computed: {

          ...mapState(['resources_logs']),

          oil_log () {
            return this.$store.getters.oil_log
          },


          fuel_log () {
            return this.$store.getters.fuel_log
          },

          // headers() {

          //  return this.getHeaders(this.resources_logs)

          // }

        },

        methods: {

          loadData(range) {

              this.$store.dispatch('fetchResourcesLogbyDate', {
                range : range

            })


          },

        
        }
    }
</script>